export class DateFormat {
  static DD_MM_YYYY_minus = 'DD-MM-YYYY';
  static MM_DD_YYYY_minus = 'MM-DD-YYYY';
  static YYYY_MM_DD_minus = 'YYYY-MM-DD';

  static DD_MM_YYYY_dot = 'DD.MM.YYYY';
  static MM_DD_YYYY_dot = 'MM.DD.YYYY';
  static YYYY_MM_DD_dot = 'YYYY.MM.DD';

  static DD_MM_YYYY_slash = 'DD/MM/YYYY';
  static MM_DD_YYYY_slash = 'MM/DD/YYYY';
  static YYYY_MM_DD_slash = 'YYYY/MM/DD';
}

export class DateTimeFormat {
  static FULL_DATETIME_minus = 'YYYY-MM-DDTHH:mm:ss';
  static TIMEZONE_ONLY = 'Z';
}
